import { render, staticRenderFns } from "./TranActivityParameterCreateDetail.vue?vue&type=template&id=c738dada"
import script from "./TranActivityParameterCreateDetail.vue?vue&type=script&lang=js"
export * from "./TranActivityParameterCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./TranActivityParameterCreateDetail.vue?vue&type=style&index=0&id=c738dada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports